import React, { Component } from 'react'
import {
  VictoryArea,
  VictoryAxis,
  VictoryChart,
  VictoryStack,
  VictoryTooltip,
  VictoryVoronoiContainer
} from 'victory'
import transformData from '../utility/transformData'
import BUOY_DATA from '../config/buoyDataClean'

const data = transformData(BUOY_DATA)
const COLOR_SKY = '#7DBCDF'
const COLOR_OCEAN = '#2C405B'
const COLOR_SNOW = '#F7F8FC'
const COLOR_ICE = '#D1DBE5'
// const COLOR_ICE = COLOR_SNOW

const yMax = Math.max(...data.map(item => item.snowDepth))
const yMin = Math.min(...data.map(item => item.iceThickness))
const xMax = new Date(Math.max(...data.map(item => item.timestamp)))
const xMin = new Date(Math.min(...data.map(item => item.timestamp)))
const yMaxMargin = yMax * 1.5
const yMinMargin = yMin * 1.1
const xMaxMargin = new Date(xMax).setHours(xMax.getHours() + 1)
// const xMinMargin = new Date(xMin).setHours(xMin.getHours() - 1)
// const xMaxMargin = new Date(xMax).setMonth(xMax.getMonth() + 1)
const xMinMargin = new Date(xMin).setHours(xMin.getHours() - 92)

// const baseProps = {}

const styles = {
  container: {
    paddingBottom: '0px',
    marginBottom: '0px'
    // position: 'absolute',
    // left: 0,
    // right: 0,
    // bottom: '0px',
    // width: '400px',
    // 'height': '500px',
    // marginTop: '-20%',
    // marginBottom: '-40%',
    // marginLeft: '-15%',
    // paddingRight: '100%'
  }
}

const createOffsets = data => {
  const dataLength = data.length
  const offsets = data.map((item, index) => {
    const { iceTemperature } = item
    const lumen = 50 + Math.min(-4.5 * iceTemperature, 50)

    return (
      <stop
        offset={`${index / dataLength * 100}%`}
        key={index}
        stopColor={`hsl(0, 100%, ${lumen}%`}
      />
    )
  })
  // const filteredOffsets = offsets.filter((offset, index) => index % 10 === 0)
  // return ( [<stop offset='0%' key='0' stopColor='lightBlue' />, <stop offset='80%' key='1' stopColor={`hsl(0, 100%, 50%)`} />] )
  return offsets
}

class IceBuoyChart extends Component {
  render () {

    return (
      <div style={{ height: '100%', width: '100%' }}>
        <svg style={{ height: '0', width: '0' }}>
          <defs>
            <linearGradient
              id='temperatureGradient'
              x1='0%'
              y1='0%'
              x2='100%'
              y2='0%'
            >
              {createOffsets(data)}
            </linearGradient>
            <linearGradient
              id='oceanGradient'
              x1='0%'
              y1='0%'
              x2='0%'
              y2='100%'
            >
              <stop offset='0%' stopColor='gray' />
              <stop offset='80%' stopColor={COLOR_OCEAN} />
            </linearGradient>
          </defs>
        </svg>
        <VictoryChart
          padding={{ bottom: 0, top: 0, left: 0, right: 0 }}
          width={450}
          height={200}
          >
        <VictoryStack
          padding={{ bottom: 0, top: 0, left: 0, right: 0 }}
          width={450}
          height={200}
          containerComponent={
            <VictoryVoronoiContainer style={styles.container} />
          }
            >
          
          <VictoryArea
            data={[
              { x: new Date(xMinMargin), y: yMaxMargin },
              { x: new Date(xMaxMargin), y: yMaxMargin }
            ]}
            style={{ data: { fill: COLOR_SKY } }}
          />
          <VictoryArea
            data={[
              { x: new Date(xMinMargin), y: yMinMargin },
              { x: new Date(xMaxMargin), y: yMinMargin }
            ]}
            style={{ data: { fill: 'url(#oceanGradient)' } }}
          />
          <VictoryArea
            data={data}
            x='timestamp'
            y='snowDepth'
            style={{ data: { fill: COLOR_SNOW } }}
            interpolation='monotoneX'
            labels={d => `Snow depth: ${d.snowDepth} cm`}
            labelComponent={<VictoryTooltip />}
          />

          <VictoryArea
            data={data}
            x='timestamp'
            y='iceThickness'
            style={{ data: { fill: COLOR_ICE } }}
            interpolation='monotoneX'
            labels={d => `Ice thickness: ${d.iceThickness} cm`}
            labelComponent={<VictoryTooltip />}
            events={[
              {
                target: 'data',
                eventHandlers: {
                  onClick: () => {
                    return [
                      {
                        target: 'data',
                        mutation: props => {
                          const { style } = props
                          const { fill } = style
                          const newFill =
                            fill === COLOR_ICE
                              ? 'url(#temperatureGradient)'
                              : COLOR_ICE
                          const newStyle = { ...props, fill: newFill }
                          return {
                            style: newStyle
                          }
                        }
                      }
                    ]
                  }
                }
              }
            ]}
            />
        </VictoryStack>
        
        <VictoryAxis scale={{ x: 'time' }} orientation='bottom' />
        </VictoryChart>
      </div>
    )
  }
}

export default IceBuoyChart



// WEBPACK FOOTER //
// ./src/charts/IceBuoyChart.js